/*
 * Datazoom, Inc ("COMPANY") CONFIDENTIAL
 * Copyright (c) 2017-2018 [Datazoom, Inc.], All Rights Reserved.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 */

import axios from "axios";
import qs from "qs";
import { baseApiV2 } from "../../constants/Presets";

export function FetchCompanies(payload) {
  const url = `${baseApiV2}company/list?`;
  const params = [];
  // if (payload.query) {
  // const query = payload.query || ""
  // params.push(`q=${query}`)
  // }
  const query =
    payload.query !== undefined
      ? encodeURIComponent(payload.query).toString()
      : "";
  params.push(`q=${query}`);
  const field = payload.field || "modifiedDate";
  params.push(`field=${field}`);
  const order = payload.order === "DESC" ? 1 : 0;
  params.push(`order=${order}`);
  const page = payload.page || 0;
  params.push(`page=${page}`);
  const size = payload.size || 0;
  params.push(`size=${size}`);
  if (payload.filters !== null) {
    const filters = encodeURIComponent(JSON.stringify(payload.filters));
    params.push(`filters=${filters}`);
  }
  const paramStr = params.join("&");
  return axios.get(url + paramStr);
}

export function FetchAllCompanies(payloadData) {
  const payload = payloadData || {};
  const url = `${baseApiV2}company/list?`;
  const params = [];
  if (payload.query) {
    params.push(`q=${payload.query}`);
  }
  const field = payload.field || "company_name";
  params.push(`field=${field}`);
  const order = payload.order || 1;
  params.push(`order=${order}`);
  const page = payload.page || 0;
  params.push(`page=${page}`);
  const size = payload.size || 1000;
  params.push(`size=${size}`);
  const paramStr = params.join("&");
  return axios.get(url + paramStr);
}

export function FetchACompany(company) {
  let payload;
  if (company !== undefined) {
    payload = `?companyId=${company}`;
  } else {
    payload = "";
  }
  return axios({
    method: "get",
    url: `${baseApiV2}company/companyDetails${payload}`,
  });
}
export function CreateCompany(company) {
  const params = {
    companyName: company.companyName,
    city: company.city || "",
    state: company.state || "",
    postcode: company.postcode || "",
    isBlocked: company.isBlocked || "y",
    countryId: company.countryId || "",
    accountType: company.accountType || "CONTRACT",
    billingStartDate: company.billingStartDate,
    hideInUi: company.hideInUi,
  };
  return axios({
    method: "post",
    url: `${baseApiV2}company/save`,
    data: params,
  });
}
export function UpdateCompany(company) {
  const url = `${baseApiV2}company/updateCompanyDetails`;
  const params = {
    companyUUID: company.companyUUID,
    companyName: company.companyName,
    city: company.city,
    state: company.state,
    postcode: company.postcode,
    countryId: company.countryId,
    isBlocked: company.isBlocked,
    accountStatus: company.accountStatus,
    accountType: company.accountType,
    billingStartDate: company.billingStartDate,
    hideInUi: company.hideInUi,
  };
  return axios.patch(url, params);
}
export function EnableCompany(id) {
  return axios({
    method: "post",
    data: qs.stringify({
      id,
    }),
    url: `${baseApiV2}companies/makeActive/`,
  });
}
export function DisableCompany(id) {
  return axios({
    method: "post",
    data: qs.stringify({
      id,
    }),
    url: `${baseApiV2}companies/makeDisabled`,
  });
}
export function DeleteCompany(id) {
  return axios({
    method: "post",
    data: qs.stringify({
      id,
    }),
    url: `${baseApiV2}companies/makeDeleted`,
  });
}

export function StarCompany(id, type) {
  return axios({
    method: type,
    url: `${baseApiV2}favorite/companies?companyId=${id}`,
  });
}
export function SwitchCompany(company) {
  const url = `${baseApiV2}company/switch_company`;
  const params = {
    companyId: company || "",
  };
  return axios.patch(url, params);
}
export function FetchACompanyLogs(companyId) {
  return axios.get(`${baseApiV2}company/getChangeLog?companyId=${companyId}`);
}
